import React from 'react'
import LineClockDollarIcon from 'components/Luxkit/Icons/line/LineClockDollarIcon'
import Pill from 'components/Luxkit/Pill'

function PayLaterPill() {
  return (
    <Pill startIcon={<LineClockDollarIcon />} kind="tertiary" variant="primary">
      Pay later
    </Pill>
  )
}

export default PayLaterPill
